import React, { useState, useEffect } from "react";
import { Avatar, Checkbox, Col, ConfigProvider, Form, Modal, Row, Space, Table } from "antd";
import Input from "../../../../components/Input/Input";
import Select from "../../../../components/Select/Select";
import Text from "../../../../components/Text/Text";
import "./../../CODiscountClass.css";
import Button from "../../../../components/Button/Button";
import { FlexCol, FlexRow } from "../../../../components/Container/Container";
import { DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import color from "../../../../resource/color";
import styled from "styled-components";
import image from "../../../../resource/image";
import { ModalSelectedProduct } from "../../../Shared/ModalSelecteProduct";
import { numberFormatter } from "../../../../utility/Formatter";
import { onInputNumberKeyPress } from "../../../../utility/validator";

const AddProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 300px;
  padding: 16px 50px;

  cursor: pointer;

  background: ${color["background1"]};
  border: 1px dashed ${color["primary"]};
  border-radius: 12px;
`;

export const CODiscountStepTwoProduct: React.FC<{
  form1: any;
  form2: any;
  errorMessage?: any;
  setErrorMessage?: any;
  productGroup?: any;
  productCategory?: any;
}> = ({ form1, form2, errorMessage, setErrorMessage, productGroup, productCategory }) => {
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const userCompany = JSON.parse(localStorage.getItem("company")!);
  const [selectProdModal, setSelectProdModal] = useState(false);
  const [sameConditionModal, setSameConditionModal] = useState(false);
  const _watchProducts = Form.useWatch("products", form2);

  const [searchText, setSearchText] = useState<any>(undefined);
  const [searchProductGroup, setSearchProductGroup] = useState<any>(undefined);
  const [searchProductCategory, setSearchProductCategory] = useState<any>(undefined);
  const [searchStrategyGroup, setSearchStrategyGroup] = useState<any>(undefined);

  const onSearch = (
    text?: string,
    proGroup?: string,
    category?: string,
    strategyGroup?: string,
  ) => {
    const products = form2.getFieldValue("products") || [];
    const filteredProducts = products.filter((product: any) => {
      const matchesSearchText =
        !text ||
        product.productName.toLowerCase().includes(text.toLowerCase()) ||
        (product.commonName && product.commonName.toLowerCase().includes(text.toLowerCase()));
      const matchesProductGroup = !proGroup || product.productGroup === proGroup;
      const matchesProductCategory = !category || product.productCategory === category;
      const matchesStrategyGroup = !strategyGroup || product.productStrategy === strategyGroup;

      return (
        matchesSearchText && matchesProductGroup && matchesProductCategory && matchesStrategyGroup
      );
    });
    form2.setFieldsValue({ searchProduct: filteredProducts });
  };

  const onDeleteProduct = () => {
    const products = form2.getFieldValue("products") || [];
    const updatedProducts = products.filter((product: any) => !product.checked);
    form2.setFieldsValue({
      products: updatedProducts,
      searchProduct: updatedProducts,
    });
  };

  const columes = [
    {
      title: (
        <Checkbox
          checked={form2.getFieldValue("searchProduct")?.every((product: any) => product.checked)}
          onChange={(e) => {
            const products = form2.getFieldValue("products") || [];
            const selectProducts = form2.getFieldValue("searchProduct") || [];
            const updatedProducts = products.map((product: any) => ({
              ...product,
              checked: e.target.checked,
            }));
            const updatedSelectProducts = selectProducts.map((product: any) => ({
              ...product,
              checked: e.target.checked,
            }));
            form2.setFieldsValue({
              products: updatedProducts,
              searchProduct: updatedSelectProducts,
            });
          }}
        />
      ),
      dataIndex: "checked",
      key: "checked",
      render: (value: any, record: any) => {
        return (
          <>
            <Checkbox
              checked={value}
              onChange={(e) => {
                const products = form2.getFieldValue("products") || [];
                const selectProducts = form2.getFieldValue("searchProduct") || [];
                const updatedProducts = products.map((product: any) => {
                  if (product.productId === record.productId) {
                    return { ...product, checked: e.target.checked };
                  }
                  return product;
                });
                const updatedSelectProducts = selectProducts.map((product: any) => {
                  if (product.productId === record.productId) {
                    return { ...product, checked: e.target.checked };
                  }
                  return product;
                });
                form2.setFieldsValue({
                  products: updatedProducts,
                  searchProduct: updatedSelectProducts,
                });
              }}
            />
          </>
        );
      },
    },
    {
      title: "ชื่อสินค้า",
      dataIndex: "productName",
      key: "productName",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexRow align='center'>
              <div style={{ marginRight: 16 }}>
                <Avatar
                  src={
                    row.productImage === "No" ||
                    row.productImage === "" ||
                    row.productImage === null
                      ? image.product_no_image
                      : row.productImage
                  }
                  size={50}
                  shape='square'
                  onError={() => false}
                />
              </div>
              <FlexCol>
                <div style={{ height: 25, textOverflow: "ellipsis" }}>
                  <Text level={5}>{row.productName}</Text>
                </div>
                {row.commonName && (
                  <div style={{ height: 25, textOverflow: "ellipsis" }}>
                    <Text level={6} style={{ color: color.Grey }}>
                      {row.commonName}
                    </Text>
                  </div>
                )}
                <div style={{ height: 25 }}>
                  <Text level={6} style={{ color: color.Grey }}>
                    Product Group : {row.productGroup}
                  </Text>
                </div>
                {row.productStrategy && (
                  <div style={{ height: 25 }}>
                    <Text level={6} style={{ color: color.Grey }}>
                      Strategy Group : {row.productStrategy}
                    </Text>
                  </div>
                )}
              </FlexCol>
            </FlexRow>
          ),
        };
      },
    },
    {
      title: "Product Code",
      dataIndex: "productCodeNAV",
      key: "productCodeNAV",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexRow>
              <FlexCol>
                <div style={{ height: 25 }}>
                  <Text level={5}>{value}</Text>
                </div>
                <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
                  <Text level={6} style={{ color: color.Grey }}>
                    Pack Size : {row.packSize}
                  </Text>
                </div>
              </FlexCol>
            </FlexRow>
          ),
        };
      },
    },
    {
      title: "ราคาขาย",
      dataIndex: "marketPrice",
      key: "marketPrice",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexRow>
              <FlexCol>
                <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
                  <Text level={5}>
                    {numberFormatter(row.marketPrice)} บาท/{row.saleUOMTH}
                  </Text>
                </div>
                {profile.company === "ICPL" && (
                  <div style={{ height: 25 }}>
                    <Text level={6} style={{ color: color.Grey }}>
                      ราคา/หน่วย : {numberFormatter(value)} บาท/{row.baseUOM || row.saleUOMTH}
                    </Text>
                  </div>
                )}
              </FlexCol>
            </FlexRow>
          ),
        };
      },
    },
    {
      title: "ส่วนลด",
      dataIndex: "discount",
      key: "discount",
      width: "20%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Space.Compact style={{ width: "100%" }}>
                <Form.Item
                  name={["products", index, "discountValue"]}
                  rules={[
                    { required: true, message: "กรุณากรอกส่วนลด" },
                    {
                      validator: (_, value) => {
                        const marketPrice = form2.getFieldValue(["products", index, "marketPrice"]);
                        const discountMode = form2.getFieldValue([
                          "products",
                          index,
                          "discountMode",
                        ]);
                        if (discountMode === "PCT_PER_UNIT" && Number(value) > 100) {
                          return Promise.reject(new Error("ส่วนลดต้องไม่เกิน 100%"));
                        }
                        if (Number(value) > Number(marketPrice)) {
                          return Promise.reject(new Error("ส่วนลดเกินราคาขาย"));
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input autoComplete='off' placeholder='0' onKeyDown={onInputNumberKeyPress} />
                </Form.Item>
                <ConfigProvider
                  theme={{
                    components: {
                      Select: {
                        selectorBg: "#F3F6F9",
                      },
                    },
                  }}
                >
                  <Form.Item name={["products", index, "discountMode"]}>
                    <Select
                      onChange={(value) => {
                        form2.validateFields([["products", index, "discountValue"]]);
                      }}
                      allowClear={false}
                      data={[
                        { label: "฿/หน่วย", value: "BAHT_PER_UNIT", key: "BAHT_PER_UNIT" },
                        { label: "%/หน่วย", value: "PCT_PER_UNIT", key: "PCT_PER_UNIT" },
                      ]}
                    />
                  </Form.Item>
                </ConfigProvider>
              </Space.Compact>
            </FlexCol>
          ),
        };
      },
    },
  ];

  return (
    <>
      <Form form={form2} layout='vertical'>
        <div style={{ paddingBottom: "10px" }}>
          <span
            className='card-label font-weight-bolder text-dark'
            style={{ fontSize: 20, fontWeight: "bold" }}
          >
            สินค้าที่เข้าร่วม{" "}
          </span>
          <Text level={6} color='error' fontWeight={600}>
            {errorMessage?.step === 1 && errorMessage?.message}
          </Text>
        </div>
        {form2.getFieldValue("products")?.length > 0 && (
          <Row justify={"space-between"} gutter={8}>
            <Col span={19}>
              <Row justify={"start"} gutter={8}>
                <Col span={12}>
                  <Input
                    placeholder='ค้นหาชื่อสินค้า'
                    suffix={<SearchOutlined />}
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      onSearch(e.target.value, searchProductGroup, searchStrategyGroup);
                    }}
                  />
                </Col>
                <Col span={4}>
                  <Select
                    data={
                      productGroup?.map((item) => ({
                        label: item.product_group,
                        value: item.product_group,
                        key: item.product_group,
                      })) || []
                    }
                    placeholder='Product Group'
                    style={{ width: "100%" }}
                    value={searchProductGroup}
                    onChange={(value) => {
                      setSearchProductGroup(value);
                      onSearch(searchText, value, searchStrategyGroup);
                    }}
                  />
                </Col>
                {profile.company === "ICPL" && (
                  <Col span={4}>
                    <Select
                      data={
                        productCategory.map((item) => ({
                          label: item.productCategoryName,
                          value: item.productCategoryId,
                          key: item.productCategoryId,
                        })) || []
                      }
                      placeholder='Product Starategy'
                      style={{ width: "100%" }}
                      value={searchProductCategory}
                      onChange={(value) => {
                        setSearchProductCategory(value);
                        onSearch(searchText, searchProductGroup, value, searchStrategyGroup);
                      }}
                    />
                  </Col>
                )}
                <Col span={3}>
                  <Button
                    typeButton='primary-light'
                    title='ล้างการค้นหา'
                    onClick={() => {
                      setSearchText(undefined);
                      setSearchProductGroup(undefined);
                      setSearchProductCategory(undefined);
                      setSearchStrategyGroup(undefined);
                      onSearch(undefined, undefined, undefined, undefined);
                    }}
                  />
                </Col>
              </Row>
            </Col>
            <Col span={5}>
              <Row justify={"end"} gutter={8}>
                {form2.getFieldValue("searchProduct")?.some((item: any) => item.checked) && (
                  <Col style={{ paddingTop: "10px" }}>
                    <DeleteOutlined
                      onClick={onDeleteProduct}
                      style={{ fontSize: "20px", color: color.error, cursor: "pointer" }}
                    />
                  </Col>
                )}
                <Col>
                  <Button
                    typeButton='primary'
                    title='เพิ่มสินค้า'
                    onClick={() => setSelectProdModal(true)}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        )}
        {form2.getFieldValue("products")?.length > 0 && (
          <>
            <br />
            <Row justify={"space-between"} gutter={8}>
              <Col span={4}>
                {form2.getFieldValue("searchProduct")?.some((item: any) => item.checked) && (
                  <Button
                    typeButton='primary-light'
                    title='ตั้งค่าเงื่อนไขเดียวกัน'
                    onClick={() => {
                      setSameConditionModal(true);
                    }}
                  />
                )}
              </Col>
              <Col style={{ paddingTop: "15px" }}>
                <Text color='Text3'>
                  จำนวนที่เลือก {form2.getFieldValue("searchProduct")?.length || 0} สินค้า
                </Text>
              </Col>
            </Row>
          </>
        )}
        <br />
        {form2.getFieldValue("products")?.length > 0 ? (
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#1B4586",
                  headerColor: "#FFFFFF",
                  fontFamily: "IBM Plex Sans Thai",
                  fontSize: 15,
                  rowHoverBg: "none",
                },
              },
            }}
          >
            <Form.Item name='products' noStyle>
              <Table
                columns={columes}
                scroll={{ x: "max-content", y: 600 }}
                dataSource={form2.getFieldValue("searchProduct") || []}
                pagination={false}
              />
            </Form.Item>
          </ConfigProvider>
        ) : (
          <AddProductContainer onClick={() => setSelectProdModal(true)}>
            <FlexCol justify='center' align='center'>
              <img src={image.addProduct} height={120} />
              <br />
              <Text level={4} color='primary'>
                + เพิ่มสินค้า
              </Text>
              <Text>โปรดเลือกสินค้าที่ต้องการ</Text>
            </FlexCol>
          </AddProductContainer>
        )}
      </Form>
      {selectProdModal && (
        <ModalSelectedProduct
          prodSelected={form2.getFieldValue("products") || []}
          company={userCompany.companyCode}
          showModalProd={selectProdModal}
          onClose={() => setSelectProdModal(!selectProdModal)}
          productGroup={productGroup || []}
          callBackProduct={(data: any) => {
            const mapProduct = data.map((item: any) => ({
              productImage: item.productImage,
              productName: item.productName,
              commonName: item.commonName,
              productCodeNAV: item.productCodeNAV,
              productGroup: item.productGroup,
              productId: item.productId,
              marketPrice: item.marketPrice,
              packSize: item.packSize,
              qtySaleUnit: item.qtySaleUnit,
              saleUOM: item.saleUOM,
              saleUOMTH: item.saleUOMTH,
              baseUOM: item.baseUOM,
              productBrandName: item.productBrand.productBrandName,
              productLocation: item.productLocation,
              discountValue: undefined,
              discountMode: "BAHT_PER_UNIT",
              checked: false,
            }));
            const mapSelectProduct = form2.getFieldValue("products")
              ? [...form2.getFieldValue("products"), ...mapProduct]
              : mapProduct;

            form2.setFieldsValue({
              products: mapSelectProduct,
              searchProduct: mapSelectProduct,
            });
            setErrorMessage({ step: undefined, message: "" });
          }}
          isDisable={true}
        />
      )}
      {sameConditionModal && (
        <Modal
          centered
          closable={true}
          maskClosable={false}
          open={sameConditionModal}
          okText='บันทึก'
          cancelText='ยกเลิก'
          onOk={async () => {
            try {
              await form2.validateFields(["sameDiscountValue"]);
              const dataForm2 = form2.getFieldsValue(true);
              const newShops = dataForm2.products.map((item: any) => {
                if (item.checked === false) return item;
                return {
                  ...item,
                  discountValue: dataForm2.sameDiscountValue || item.discountValue,
                  discountMode: dataForm2.sameDiscountMode || item.discountMode,
                  checked: false,
                };
              });
              form2.setFieldsValue({
                products: newShops,
                searchProduct: newShops,
                sameDiscountValue: undefined,
                sameDiscountMode: undefined,
              });
              form2.validateFields();
              setSameConditionModal(false);
            } catch (error) {
              console.log("same condition error", error);
            }
          }}
          onCancel={() => setSameConditionModal(false)}
          title={
            <Text fontWeight={600} level={4}>
              ตั้งค่าพร้อมกันทุกสินค้า
            </Text>
          }
        >
          <Form form={form2} layout='vertical'>
            <div>ตั้งส่วนลดทุกสินค้า</div>
            <Space.Compact style={{ width: "100%" }}>
              <Form.Item
                name='sameDiscountValue'
                style={{ flex: 1, marginBottom: 0 }}
                rules={[
                  {
                    validator: (_, value) => {
                      const discountMode = form2.getFieldValue("sameDiscountMode");
                      if (discountMode === "PCT_PER_UNIT" && Number(value) >= 100) {
                        return Promise.reject(new Error("ส่วนลดต้องไม่เกินหรือเท่ากับ 100%"));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input autoComplete='off' placeholder='0' onKeyDown={onInputNumberKeyPress} />
              </Form.Item>
              <Form.Item name='sameDiscountMode' style={{ width: 120, marginBottom: 0 }}>
                <ConfigProvider
                  theme={{
                    components: {
                      Select: {
                        selectorBg: "#F3F6F9",
                      },
                    },
                  }}
                >
                  <Select
                    allowClear={false}
                    data={[
                      { label: "฿/หน่วย", value: "BAHT_PER_UNIT", key: "BAHT_PER_UNIT" },
                      { label: "%/หน่วย", value: "PCT_PER_UNIT", key: "PCT_PER_UNIT" },
                    ]}
                    onChange={(value) => {
                      form2.setFieldsValue({ sameDiscountMode: value });
                      form2.validateFields(["sameDiscountValue"]);
                    }}
                  />
                </ConfigProvider>
              </Form.Item>
            </Space.Compact>
          </Form>
        </Modal>
      )}
    </>
  );
};
